'use client'
import React, { useEffect, useState } from 'react';
import { useParams } from 'next/navigation';
// import "@/app/global.css";
import { INITIAL_LOCALE } from '@/libs/constants'


const TableOfContents = () => {
    const [contentHeadings, setContentHeadings] = useState<HTMLHeadingElement[]>([]);
    const [isClientSide, setIsClientSide] = useState(false);
    const [openIndexes, setOpenIndexes] = useState<number[]>([]);
    const [isPageLoaded, setIsPageLoaded] = useState(true);
    const { locale } = useParams();

    const translates = {
        'vi-VN': {
            title: 'Mục Lục',
        },
        'en-US': {
            title: 'Table Of Contents',
        },
        'zh-CN': {
            title: 'Table Of Contents',
        },
        'ko-KR': {
            title: 'Table Of Contents',
        }
    } as any

    useEffect(() => {
        const h2 = Array.from(document.querySelectorAll('h2'));
        setContentHeadings(h2);
        setIsClientSide(true);
        setIsPageLoaded(false);
    }, []);

    useEffect(() => {
        if (isPageLoaded) {
            setOpenIndexes(contentHeadings.map((_, index) => index));
        }
    }, [isPageLoaded, contentHeadings]);


    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            contentHeadings.forEach((heading, index) => {
                const nextHeading = contentHeadings[index + 1];
                const headingTop = heading.offsetTop;
                const nextHeadingTop = nextHeading ? nextHeading.offsetTop : Infinity;

                if (scrollPosition >= headingTop && scrollPosition < nextHeadingTop) {
                    setOpenIndexes([index]);
                }
            });
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [contentHeadings]);


    const convertToSlug = (text: string | null) => {
        if (!text) return '';

        const slug = text
            .toLowerCase()
            .normalize('NFD')
            .replace(/đ/g, 'd')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^\w\s]/g, '-')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-*/, '')
            .replace(/-*$/, '');

        return slug;
    };
    return (
        <div className='sticky-top-tb top-15'>
            <p className='fw-semi-bold fs-5'>{translates[(locale || INITIAL_LOCALE) as any].title}</p> 
            <ul className='w-100 mt-3 bg-grey-50 list-unstyled'>
                {contentHeadings?.filter((heading) => heading.textContent).map((heading, index) => {
                    // @ts-ignore
                    const h3 = [...heading?.parentElement?.querySelectorAll("h3")];
                    const isOpen = openIndexes.includes(index);
                    return (
                        <React.Fragment key={index}>
                            <li key={index}
                                onClick={() => {
                                    setOpenIndexes([index]);
                                    heading.scrollIntoView({
                                        behavior: "smooth",
                                        inline: "start",
                                        block: "start",
                                    });
                                }}
                                className={`cursor-pointer transition-all  border-start-2 text-base ps-4 ${isOpen ? ' bd-primary bg-lavender bg-opacity-75' : 'border-start-2 ps-4 '}`} >
                                <div className={`align-items-start fw-semi-bold ${isOpen ? 'text-black' : ''}`}>
                                    <a href={`#${convertToSlug(heading.textContent)}`} className={`d-block py-2 h4 lh-sm ${isOpen ? 'text-primary text-decoration-none' : 'text-grey-500 hover:text-grey-500 text-decoration-none'}`}>{heading.textContent}</a>
                                </div>
                            </li>
                            <ul className='ms-5 list-unstyled'>
                                {h3?.filter(h3 => h3.textContent)?.map((h3, subIndex) => {
                                    return (
                                        <li
                                            key={subIndex}
                                            onClick={() => {
                                                h3.scrollIntoView({
                                                    behavior: "smooth",
                                                    inline: "start",
                                                    block: "start",
                                                });
                                            }}
                                        >
                                            <a href={`#${convertToSlug(h3.textContent)}`} className={'h5 py-2 text-grey-500 hover:text-grey-500 text-decoration-none'}>{h3?.textContent}</a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </React.Fragment>

                    );
                })}
            </ul>
        </div>
    );
}

export default TableOfContents;